export default __webpack_public_path__ + "static/brand-14-231c0028b7691a6178c4b43a525525e7.png";